<template>
  <div class="signUpFinish">
    <div class="signUpFinish__content">
      <div class="signUpFinish__mainText">
        Вы успешно создали аккаунт.
      </div>
      <div class="signUpFinish__infoText">
        Проверьте свою почту, чтобы подтвердить регистрацию
      </div>
    </div>
    <ActionButton
        style="width: 180px"
        icon-type="arrow"
        @button-click="$router.push({name: 'HomePage'})"
    >
      <template #caption>На главную</template>
    </ActionButton>
  </div>
</template>

<script>
import ActionButton from "@/components/ui/ActionButton.vue";

export default {
  name: "SignUpFinishView" ,
  components: {ActionButton}
}
</script>


<style scoped lang="scss">
.signUpFinish {
  height: 410px;
  border-radius: 20px;
  padding: 34px;
  opacity: 1;
  background: var(--cd-card-bg);
  text-align: center;

  &__content {
    width: 498px;
    margin: 0 auto;
  }

  &__mainText {
    font-family: var(--cd-bold-font);
    font-weight: 500;
    font-size: 36px;
    margin: 65px 20px;
  }

  &__infoText {
    margin: 40px 34px;
    font-size: 16px;
    font-family: var(--cd-default-font);

    a {
      color: #62C064;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
